import type { ReactNode } from "react";

type Variant = "auto" | "user" | "review" | "unmatched" | "neutral" | "accent";

const variants: Record<Variant, string> = {
  auto: "bg-[#F1F8F2] text-[#1C5125] border-[#BFE0C4]",
  user: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  review: "bg-[#FFF7ED] text-[#9A3412] border-[#FED7AA]",
  unmatched: "bg-[#FEF2F2] text-[#991B1B] border-[#FECACA]",
  neutral: "bg-gray-100 text-gray-700 border-gray-200",
  accent: "bg-accent-50 text-accent-700 border-accent-100",
};

export function Badge({ variant = "neutral", children, className = "" }: {
  variant?: Variant;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}

export function bucketVariant(link_status: string, license_number: string | null, user_confirmed?: boolean): Variant {
  if (link_status === "confirmed") return user_confirmed ? "user" : "auto";
  if (link_status === "suggested" && license_number) return "review";
  if (link_status === "suggested" && !license_number) return "unmatched";
  return "neutral";
}

export function bucketLabel(link_status: string, license_number: string | null, user_confirmed?: boolean): string {
  if (link_status === "confirmed") return user_confirmed ? "USER_MATCHED" : "AUTO_APPROVED";
  if (link_status === "suggested" && license_number) return "NEEDS_REVIEW";
  if (link_status === "suggested" && !license_number) return "UNMATCHED";
  if (link_status === "delivery_partner") return "DELIVERY_PARTNER";
  if (link_status === "not_a_retailer" || link_status === "off_platform") return "NOT_A_RETAILER";
  if (link_status === "rejected") return "SKIPPED";
  return link_status.toUpperCase();
}
